
import React from "react";
import { 
  Carousel, 
  CarouselContent, 
  CarouselItem, 
  CarouselNext, 
  CarouselPrevious 
} from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { motion } from "framer-motion";

const images = [
  "/lovable-uploads/6238269c-1d4e-47d3-9b7f-9898605261ea.png", 
  "/lovable-uploads/81f8fc30-883f-408e-bbb6-f0670bb4ee55.png", 
  "/lovable-uploads/6d4be08b-3682-4b4b-afb9-1a4a24f53b1c.png", 
  "/lovable-uploads/fc11d0b3-17c0-43d9-9e7b-70cac7cdf6b5.png", 
  "/lovable-uploads/e1b667cd-e6a9-4927-ae11-64badba95792.png", 
  "/lovable-uploads/ab3f3936-6d24-42f0-9930-09df6906158e.png", 
  "/lovable-uploads/f76dbc95-94b3-47ae-b78c-d0ff6d63643b.png", 
  "/lovable-uploads/b1b5fa43-0204-4d07-9524-b21b42bb4a96.png"
];

interface BookingImageCarouselProps {
  className?: string;
}

export const BookingImageCarousel: React.FC<BookingImageCarouselProps> = ({ className }) => {
  return (
    <div className={className}>
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        className="w-full"
      >
        <CarouselContent>
          {images.map((src, index) => (
            <CarouselItem key={index} className="md:basis-1/1 lg:basis-1/1">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="overflow-hidden rounded-xl"
              >
                <AspectRatio ratio={4/5} className="bg-secondary/20">
                  <img 
                    src={src} 
                    alt={`Pottery workshop scene ${index + 1}`} 
                    className="object-cover w-full h-full rounded-xl" 
                  />
                </AspectRatio>
              </motion.div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="hidden md:block">
          <CarouselPrevious className="left-2" />
          <CarouselNext className="right-2" />
        </div>
      </Carousel>
    </div>
  );
};
